import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34cf6acd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-placeholder no-print" }, null, -1))
const _hoisted_2 = {
  class: "navbar navbar-expand-lg navbar-light bg-white no-print",
  id: "navbar"
}
const _hoisted_3 = { class: "col-lg-12 d-flex justify-content-center p-1 brand-container" }
const _hoisted_4 = {
  class: "navbar-brand",
  href: "/"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 0,
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNav",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "collapse navbar-collapse justify-content-center",
  id: "navbarNav"
}
const _hoisted_10 = { class: "navbar-nav" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item" }

import { useAuthStore } from "@/stores/auth";
import brand from "@/brand";
import { useMiscStore } from "@/stores/misc";
import { useMediaQuery } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const authStore = useAuthStore();
const miscStore = useMiscStore();

let lastScrollTop = 0;

window.addEventListener("scroll", () => {
  const navbar = document.getElementById("navbar");
  const isLg = useMediaQuery('(min-width: 992px)')

  if (navbar) {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    let navTop = "0px";

    if (scrollTop > lastScrollTop) {
      if (isLg) {
        const links = document.getElementById("navbarNav") || { clientHeight: 0 };
        navTop = `-${navbar.clientHeight - (links.clientHeight * 1.25)}px`;
      }
      else {
        navTop = `-${navbar.clientHeight}px`;
      }
    }

    navbar.style.top = navTop;

    lastScrollTop = scrollTop;
  }
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["container-fluid flex-lg-wrap", { 'justify-content-end': !_unref(authStore).isLoggedIn }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _createElementVNode("img", {
              src: _unref(brand).logo,
              alt: `${_unref(brand).name} Logo`,
              class: "img-fluid h-100"
            }, null, 8, _hoisted_5)
          ])
        ]),
        (_unref(authStore).isLoggedIn)
          ? (_openBlock(), _createElementBlock("button", _hoisted_6, _hoisted_8))
          : _createCommentVNode("", true),
        (_unref(authStore).isLoggedIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("ul", _hoisted_10, [
                _createElementVNode("li", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    to: { name: 'Dashboard' },
                    class: "nav-link",
                    "active-class": "active",
                    "aria-current": "page"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Dashboard")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_12, [
                  _createVNode(_component_router_link, {
                    to: { name: 'Profile' },
                    class: "nav-link",
                    "active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("My Profile")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_13, [
                  _createVNode(_component_router_link, {
                    to: { name: 'Products' },
                    class: "nav-link",
                    "active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("My Products")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "nav-link",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(authStore).logout()))
                  }, "Logout")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ], 64))
}
}

})